// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"59":"4d14ea692ef69a07adf9","925":"ae56fa8c03742e356b48"}[chunkId] + ".bundle.js";
};